exports.IDS = {
  // IMG_URL: "http://127.0.0.1:8787",
  IMG_URL: "https://omtapovan-node.profcymadev.com:2002",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  users: {
    admin: 1,
    builder: 2,
    customer: 3,
  },

  addressTypes: {
    Home: 1,
    Apartment: 2,
    Work: 3,
  },

  usersrole: {
    admin: "Admin",
    builder: "Builder",
    customer: "Customer",
  },

  legal_verification_status: {
    process: 1,
    approved: 2,
    rejected: 3,
  },

  Payment_Methods: {
    Cash: 1,
    Card: 2,
    Qr: 3,
    Wallete: 4,
    Online: 5,
  },
};
